<template lang="pug">
    el-dialog(:title="!ruleForm.byx1 ? '添加': '修改'",  :fullscreen="false" :visible.sync='visible' :modal-append-to-body='false' :append-to-body='true' @close="visible=false")
      el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="90px",label-position='right' @submit.native.prevent)
        el-form-item(label="名　　称:" prop="title" )
            el-input(style='width:100%;' v-model="ruleForm.title" placeholder="请输入模板名称")
        el-form-item(label="设　　置:" )
            el-button(type="primary" @click='addRow') 添加
            el-button(type="danger" @click='delList' :disabled='delDisable') 删除
            el-row(style='margin-top:15px;')
                el-col(:span='13')
                    el-form-item(label="报名时间距开始时间≤"   prop="typeVal" label-width="150px" )
                        el-input-number(v-model="ruleForm.typeVal" :min="0" style='width:150px;' :max="100000000" :step="1")
                        font &nbsp;&nbsp;小时
                el-col(:span='11')
                    el-form-item(label="退款比例:" prop="value" )
                        el-input-number(v-model="ruleForm.value" style='width:150px;' :min="0" :max="100")
                        font &nbsp;&nbsp;%
        el-form-item
            el-table(:data="ruleForm.feeList" border  @selection-change='selectionChangeHandle')
                el-table-column(type='selection', header-align='center', align='center', width='50')
                el-table-column(prop="typeVal" label="距离开始时间/小时（含）" align='center')
                el-table-column(prop="value" label="退款比例/%" align='center')

        el-form-item(label="模板介绍:" prop="remark" )
            el-input(type='textarea' :rows='5' resize='none' v-model='ruleForm.remark' placeholder="请输入模板介绍")

      span.dialog-footer(slot="footer")
          el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 确 定
          el-button(@click="visible=false") 取 消
</template>
<script>
    export default {
        data () {
            return {
                clickFlag: false,
                delDisable: true,
                delTableList: [],
                ruleForm: {
                    id: null,
                    byx1: '',
                    title: '',
                    remark: '',
                    feeList: []
                },
                flagType: '',
                loading: null,
                rules: {
                    title: [
                        { required: true, message: '名称不能为空!', trigger: 'blur' },
                        { max: 50, message: '长度不能超过50个字符!' }
                    ],
                    remark: [
                        { required: true, message: '模板介绍不能为空!', trigger: 'blur' },
                        { max: 500, message: '长度不能超过500个字符!' }
                    ]
                },
                visible: false
            }
        },
        methods: {
            init (byx1, flagType) {
                this.clickFlag = false
                this.flagType = flagType
                this.ruleForm.byx1 = byx1 || null
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields()
                })
                this.ruleForm.feeList = []
                this.ruleForm.title = ''
                this.ruleForm.remark = ''
                //修改回选
                if (this.ruleForm.byx1) {
                    this.$http({
                        url: this.$http.adornUrl(`/pbFeeTemplate/getByByx1/` + this.ruleForm.byx1),
                        method: 'get'
                    }).then((data) => {
                        if (data && data.code === 0) {
                            console.log('data222:', data.list[0])
                            this.ruleForm.title = data.list[0].title
                            this.ruleForm.remark = data.list[0].remark
                            this.ruleForm.feeList = data.list
                            console.log('初始化后的数据：', this.ruleForm.feeList)
                        }
                    })
                }
            },
            openFullScreen () {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                setTimeout(() => {
                this.loading.close()
                }, 2000)
            },
            //新增方法
            ruleFormSubmit () {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        // this.clickFlag = true
                        if (!this.ruleForm.feeList || this.ruleForm.feeList.length == 0) {
                            this.$message.error('请添加退费设置')
                            return
                        }
                        console.log('要提交的数据1：', this.ruleForm.feeList)
                        this.ruleForm.feeList.forEach(e => {
                            e.title = this.ruleForm.title
                            e.remark = this.ruleForm.remark
                            e.byx1 = this.ruleForm.byx1
                            e.typeTemp = 2//模板类型（1报名费用，2退款费用）
                        })
                        console.log('要提交的数据2：', this.ruleForm.feeList)
                        this.openFullScreen()
                        this.$http({
                            url: this.$http.adornUrl(`/pbFeeTemplate/saveList`),
                            method: 'post',
                            data: this.ruleForm.feeList
                        }).then((data) => {
                            this.loading.close()
                            console.log('提交后返回的结果：', data)
                            if (data && data.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.flagType = 1
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            },
            addRow () {
                let flag = false
                 console.log('新加的数据：', this.ruleForm)
                if (this.ruleForm.typeVal === undefined || this.ruleForm.value === undefined) {
                    this.$message.error('请添加距离开始时间和退款比例！！')
                     flag = true
                }
                this.ruleForm.feeList.forEach(e => {
                    if (e.typeVal === this.ruleForm.typeVal) {
                        this.$message.error('该时间已添加！')
                        flag = true
                    }
                })

                if (!flag) {
                    this.newRow = {
                        title: this.ruleForm.title,
                        remark: this.ruleForm.remark,
                        byx1: this.ruleForm.byx1,
                        typeVal: this.ruleForm.typeVal,
                        value: this.ruleForm.value
                    }
                    this.ruleForm.feeList.push(this.newRow)
                    console.log('添加后的数据：', this.ruleForm.feeList)
                }
            },
            delList () {
                console.log('选择要删除的数据：', this.delTableList)
                this.delTableList.forEach(e => {
                    console.log('循环的数据：', e)
                    for (let b of this.ruleForm.feeList) {
                        if (e.typeVal == b.typeVal) {
                            this.ruleForm.feeList.splice(b.index - 1, 1)
                        }
                    }
                })
                console.log('删除后的数据：', this.ruleForm.feeList)
            },
            // table多选事件
            selectionChangeHandle (val) {
                console.log('已选择的数据：', val)
                this.delTableList = val
                if (this.delTableList.length === 0) {
                    this.delDisable = true
                } else {
                    this.delDisable = false
                }
                console.log('已选择赋值的数据：', this.delTableList)
            }
        }
    }
</script>
<style>
    .inputWidth{
        width: 210px;
    }

    .font_later{
        padding-left:20px;
        font-weight: bold;
        color: #909399;
    }
    .font_color{
        font-weight: bold;
        color: #909399;
    }
    .font_style{
        font-weight: bold;
        color: red;
    }
    .dialog-footer{
        padding-bottom:150px;
    }

    /* 提示框 */
.el-tooltip__popper.is-light{
  border: 1px solid #C0C4CC;
}

.el-tooltip__popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: grey  !important ;
}

.toolTip>p{
  margin: 0;
  padding-top: 10px;
  height:14px;
  line-height:14px;
  font-size:14px;
  color: #606266;
}

 /* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

</style>
